import { useEffect } from 'react';

const eventosDeAtividade = [
  'mousemove',
  'mousedown',
  'keydown',
  'touchstart',
  'wheel',
  'scroll',
] as const;

/**
 * Bloqueia a sessao depois de um tempo sem atividade.
 *
 * O tempo vem da empresa (aba Acesso das configuracoes). O valor do OnPoint nao e
 * conhecido, e por isso o padrao e desligado: sem minutos, nada acontece. Quem
 * administra a empresa liga digitando o tempo.
 *
 * Bloquear e levar a /sessao-bloqueada, que encerra a sessao no servidor e pede a
 * senha de novo. Uma tela apenas coberta, com a sessao viva por baixo, nao protegeria
 * nada de quem senta na frente do computador.
 */
export function useIdleLock(
  minutos: number | null | undefined,
  aoBloquear: () => void,
): void {
  useEffect(() => {
    if (!minutos || minutos <= 0) return;

    const espera = minutos * 60_000;
    let relogio = window.setTimeout(aoBloquear, espera);
    const reiniciar = () => {
      window.clearTimeout(relogio);
      relogio = window.setTimeout(aoBloquear, espera);
    };

    for (const evento of eventosDeAtividade) {
      window.addEventListener(evento, reiniciar, { passive: true });
    }
    return () => {
      window.clearTimeout(relogio);
      for (const evento of eventosDeAtividade) {
        window.removeEventListener(evento, reiniciar);
      }
    };
  }, [minutos, aoBloquear]);
}
